export function buildListeGardesValideeUrl(mois, typeGarde = "PR2") {
  return `/api/v2/liste_gardes/${encodeURIComponent(mois)}?type=${encodeURIComponent(typeGarde)}`;
}

export function buildEstValideeGardesUrl(mois, typeGarde = "PR2") {
  return `/api/v2/liste_gardes/est_validee/${encodeURIComponent(mois)}?type=${encodeURIComponent(typeGarde)}`;
}

export function normalizeListeGardes(liste) {
  if (!liste || typeof liste !== "object" || Array.isArray(liste)) return [];

  return Object.entries(liste)
    .filter(([date]) => /^\d{4}-\d{2}-\d{2}$/.test(date))
    .sort(([dateA], [dateB]) => dateA.localeCompare(dateB))
    .map(([date, medecin]) => ({ date, medecin }));
}

export function formatMedecinGarde(medecin) {
  if (!medecin) return "Non attribué";
  return String(medecin).replace(/_/g, " ");
}

export async function fetchListeGardesValidee({
  mois,
  typeGarde = "PR2",
  fetchImpl = fetch,
} = {}) {
  const etatRes = await fetchImpl(buildEstValideeGardesUrl(mois, typeGarde), { cache: "no-store" });
  if (!etatRes.ok) {
    throw new Error("Impossible de vérifier la validation de la liste de gardes.");
  }

  const etat = await etatRes.json();
  if (!etat.estValidee && !etat.valide) {
    return { estValidee: false, lignes: [] };
  }

  const listeRes = await fetchImpl(buildListeGardesValideeUrl(mois, typeGarde), { cache: "no-store" });
  if (listeRes.status === 404) {
    return { estValidee: false, lignes: [] };
  }
  if (!listeRes.ok) {
    throw new Error("Impossible de charger la liste de gardes validée.");
  }

  return {
    estValidee: true,
    lignes: normalizeListeGardes(await listeRes.json()),
  };
}
